<script lang="ts">
  import { page } from '$app/stores';
  import FlucPeriodDropdown from '$components/preferences/FlucPeriodDropdown.svelte';
  import type { LayoutPreference } from '$types/races';
  import { isSubscribed } from '$utils/auth';
  import { selectedRaceHasSP } from '$utils/race';

  $: ({ layoutConfigStore } = $page.data);

  export let computedLayoutPreferences: LayoutPreference[];
  export let betfairMarketTypes: ('win' | 'place')[];

  function fullType(preference: LayoutPreference) {
    if (preference.bookmaker === 'Betfair') {
      let abb = '';
      abb += preference.type === 'FIXED_WIN' ? 'Win Market ' : 'Place Market ';
      const level =
        preference.level === 'WEIGHTED_AVERAGE'
          ? 'Weighted Average'
          : 'level ' + preference.level;
      abb +=
        preference.side === 'BACK'
          ? 'Back (' + level + ')'
          : 'Lay (' + level + ')';
      return abb;
    }

    switch (preference.type) {
      case 'FIXED_WIN':
        return 'Fixed Win';
      case 'FIXED_PLACE':
        return 'Fixed Place';
      case 'FIXED_WIN_FLUCS':
        return 'Fixed Win Flucs';
      case 'FIXED_PLACE_FLUCS':
        return 'Fixed Place Flucs';
      default:
        return preference.type;
    }
  }

  function abbreviateType(preference: LayoutPreference) {
    if (preference.bookmaker === 'Betfair') {
      // simplify this if the user isn't subscribed
      if (!$isSubscribed) {
        if (preference.side == 'BACK') {
          return 'Back';
        } else {
          return 'Lay';
        }
      }

      //   if we are on the default layout, just show the type
      if (layoutConfigStore?.isActiveDefault()) {
        if (preference.side == 'BACK') {
          return 'Back';
        } else {
          return 'Lay';
        }
      }

      let abb = '';
      abb += preference.type === 'FIXED_WIN' ? 'W' : 'P';
      abb += preference.side === 'BACK' ? 'B' : 'L';
      const level =
        preference.level === 'WEIGHTED_AVERAGE'
          ? 'WA'
          : getBetfairLevel(preference);
      abb += level;
      return abb;
    }

    switch (preference.type) {
      case 'FIXED_WIN':
        return 'FW';
      case 'FIXED_PLACE':
        return 'FP';
      case 'FIXED_WIN_FLUCS':
        return 'FW';
      case 'FIXED_PLACE_FLUCS':
        return 'FP';
      default:
        return preference.type;
    }
  }

  function getBackgroundClass(preference: LayoutPreference) {
    // if (preference.bookmaker === Bookmaker.BETFAIR) {
    //   return 'bg-slate-700/10 text-center font-mono text-white';
    // }
    switch (preference.type) {
      case 'FIXED_WIN':
        return '  ';
      case 'FIXED_PLACE':
        return 'bg-stone-300 text-gray-900';
      case 'FIXED_WIN_FLUCS':
        return '  ';
      case 'FIXED_PLACE_FLUCS':
        return 'bg-stone-300 text-gray-900';
      default:
        return '  ';
    }
  }

  function getBetfairLevel(preference: LayoutPreference) {
    switch (preference?.level) {
      case 'ZERO':
        return 0;
      case 'ONE':
        return 1;
      case 'TWO':
        return 2;
      default:
        return 0;
    }
  }
</script>

<tr
  class="border-slate-200 bg-slate-100 text-center text-[10px] font-bold text-gray-700"
>
  {#if $selectedRaceHasSP}
    {#each betfairMarketTypes as betfairMarketType}
      {@const bfPriceType = betfairMarketType.toLowerCase().includes('place')
        ? 'P'
        : 'W'}
      <td
        class="truncate {bfPriceType === 'P' ? 'bg-slate-100' : ''}"
        title="Starting Price">{bfPriceType}SP</td
      >
    {/each}
  {/if}
  {#each computedLayoutPreferences as layoutPreference}
    {#if layoutPreference.type === 'FIXED_WIN_FLUCS' || layoutPreference.type === 'FIXED_PLACE_FLUCS'}
      <td
        class="{layoutPreference.type === 'FIXED_WIN_FLUCS'
          ? 'bg-slate-100'
          : 'bg-stone-300 text-gray-900'} relative"
      >
        <FlucPeriodDropdown {layoutPreference} />
      </td>
    {:else if (!$selectedRaceHasSP || layoutPreference.bookmaker !== 'Betfair') && layoutPreference.bookmaker}
      <td
        class="{getBackgroundClass(layoutPreference)} truncate"
        title={fullType(layoutPreference)}
      >
        {abbreviateType(layoutPreference)}
      </td>
    {:else if layoutPreference.type === 'SPACER'}
      <td class="w-6 bg-white" />
    {:else if layoutPreference.type === 'TEXT'}
      <td class="">TXT</td>
    {:else if layoutPreference.type === 'BEST_PRICE_WIN'}
      <td class="" colspan={4}>Win</td>
    {:else if layoutPreference.type === 'BEST_PRICE_PLACE'}
      <td class="bg-stone-300 text-gray-900" colspan={4}>Place</td>
    {/if}
  {/each}
</tr>
